import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { EventManager } from 'src/app/core/services';
declare let $;
@Injectable({ providedIn: 'root' })
export class ExecuteBeforeRequestInterceptor implements HttpInterceptor {
  private readonly SERVER_API_URL: any;
  extra: any;
  quanlity: any = 0;
  singleAPIs: any = {};
  modalRef: any;
  isLoad: boolean = false;
  constructor(
    private eventManager: EventManager,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpResponse<any>> {
    this.beforeRequest();
    return next.handle(request)
    .pipe(
      tap(
        (res: HttpResponse<any>) => {
          if (res.status) {
            this.hideSpinner();
          }
          const version = localStorage.getItem("version");
          this.extra = res.body ? res.body.extra : null;
          if (this.extra) {
            if (version && this.extra.clientVersion > version) {
                localStorage.setItem("version", this.extra.clientVersion);
                location.reload();
            } else  if (!version) {
                localStorage.setItem("version", this.extra.clientVersion);
            }
         }
        },
        (err: any) => {
          this.hideSpinner();
          return err;
        }
      ),
    )
  }
  private beforeRequest(): void {
    this.quanlity++;
    // show spinner
    if (this.isLoad) {
      return;
    }
    this.isLoad = true;
    setTimeout(() => {
      if (!this.isLoad) {
        return;
      }
      this.eventManager.broadcast({
        name: 'show-spinner',
        content: {}
      });
    }, 1000)
  }
  hideSpinner() {
    this.quanlity--;
    // close spinner
    if (this.quanlity == 0) {
      this.isLoad = false;
      this.eventManager.broadcast({
        name: 'close-spinner',
        content: {}
      })
    }
  }
}
